<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="2">
          <v-sheet rounded="lg">
            <v-list-item
              v-for="(item, index) in listItems"
              :key="index"
              :class="{ active: currentTab === item.name }"
              @click="selectTab(item.name)">
              {{ item.label }}
            </v-list-item>
          </v-sheet>
        </v-col>

        <v-col>
          <v-sheet min-height="70vh" rounded="lg">
            <component :is="currentComponent" @snack="throwSnack" />
          </v-sheet>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import { useSnack } from '@/helpers';
import CastCrewSettingsSubView from './subviews/CastCrewSettingsSubView.vue';
import SystemSettingsSubView from './subviews/SystemSettingsSubView.vue';
import { SNACKSTATUS } from '@/stores/util';
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import JudgeSpecialitesSubView from './subviews/JudgeSpecialitesSubView.vue';

const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();

const { throwSnack } = useSnack(emit);
const route = useRoute();
const router = useRouter();

const listItems = computed(() => [
  {
    name: 'system',
    label: 'System Settings',
    component: SystemSettingsSubView,
  },
  {
    name: 'castcrew',
    label: 'Cast Crew Settings',
    component: CastCrewSettingsSubView,
  },
  {
    name: 'judge',
    label: 'Judge Specialties',
    component: JudgeSpecialitesSubView,
  },
]);

const currentTab = ref(route.params.tabName || 'system');

const currentTabItem = computed(() => listItems.value.find((i) => i.name === currentTab.value));

const currentComponent = computed(() => currentTabItem.value?.component || null);

function selectTab(tabName: string) {
  currentTab.value = tabName;
}

watch(
  currentTab,
  (newTab) => {
    router.push({
      name: 'AdminSettings',
      params: { tabName: newTab },
    });
  },
  { immediate: true },
);
</script>
